import axios from 'axios';

import { BACKEND_API_URI } from '@constants';
import { retrieveAccessToken } from '@utils';

const orderUrl = orderId => `${BACKEND_API_URI}/orders/${orderId}`;
const paymentsUrl = (orderId, paymentProcessor) =>
  paymentProcessor !== 'ach'
    ? `${orderUrl(orderId)}/payments`
    : `${orderUrl(orderId)}/payments?paymentProcessor=STRIPE`;
const plaidLinkTokenUrl = orderId =>
  `${orderUrl(orderId)}/payments/getLinkToken`;
const stripeUrl = `${BACKEND_API_URI}/stripe`;
const stripeConfigUrl = currency => `${stripeUrl}/config?currency=${currency}`;
const getBigCommerceLoginUrl = `${BACKEND_API_URI}/bigcommerce/login`;

export const getLinkToken = async orderId => {
  const { data } = await axios.get(plaidLinkTokenUrl(orderId), {
    headers: {
      Authorization: `Bearer ${retrieveAccessToken()}`,
    },
  });

  return data.linkToken;
};

export const createPayment = async (
  publicToken,
  accountId,
  amount,
  orderId,
  linkSessionId
) => {
  const { data } = await axios.post(
    paymentsUrl(orderId),
    {
      publicPlaidToken: publicToken,
      plaidBankAccountId: accountId,
      amount,
      orderId,
      linkSessionId,
    },
    {
      headers: {
        Authorization: `Bearer ${retrieveAccessToken()}`,
      },
    }
  );

  return data;
};

export const createPadPayment = async (amount, orderId, paymentProcessor) => {
  const { data } = await axios.post(
    paymentsUrl(orderId, paymentProcessor),
    {
      amount,
    },
    {
      headers: {
        Authorization: `Bearer ${retrieveAccessToken()}`,
      },
    }
  );

  return data;
};

export const submitPaymentIntent = async (orderId, paymentIntentId) =>
  await axios
    .patch(
      paymentsUrl(orderId),
      {
        paymentIntentId,
      },
      {
        headers: {
          Authorization: `Bearer ${retrieveAccessToken()}`,
        },
      }
    )
    .then(({ data }) => data);

export const getOrder = orderId =>
  axios
    .get(`${orderUrl(orderId)}`, {
      headers: {
        Authorization: `Bearer ${retrieveAccessToken()}`,
      },
    })
    .then(({ data }) => data);

export const getCommerceStripePublicKeys = currency =>
  axios
    .get(`${stripeConfigUrl(currency)}`, {
      headers: {
        Authorization: `Bearer ${retrieveAccessToken()}`,
      },
    })
    .then(({ data }) => data);

export const getBigcommerceSSOUrl = async (email, firstName, lastName) => {
  const { data } = await axios.post(
    getBigCommerceLoginUrl,
    {
      first_name: firstName,
      last_name: lastName,
      email: email,
    },
    {
      headers: {
        Authorization: `Bearer ${retrieveAccessToken()}`,
      },
    }
  );
  return data.url;
};
